export const RegexIP = new RegExp(
  '^(([1]?[0-9]{1,2}|2([0-4][0-9]|5[0-5])).){3}([1]?[0-9]{1,2}|2([0-4][0-9]|5[0-5]))$'
);
export const ddrRegex = new RegExp('^(\\d{4}|\\d{8}|\\d{10})$');
